require('./RASustainabilityInvestmentFactorsQuestion.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

//@components
const RASustainabilityDisclaimer = require('../RASustainabilityDisclaimer/RASustainabilityDisclaimer');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const RARadioButtonStep = require('../RARadioButtonStep/RARadioButtonStep');
const RASustainabilityModal = require('../../components/RASustainabilityInvestmentFactorsQuestion/components/RASustainabilityModal');

//@utilities
const { FormattedText } = require('core/i18n').i18n;
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { PROC_RA_SUITABILITY_TEST } = require('utilities/tagging');

class RASustainabilityInvestmentFactorsQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAdditionalQuestions: false,
            isAccordionHeaderHidden: true,
            isAccordionExpanded: true,
        };
        this.doTagging = this.doTagging.bind(this);
    }

    doTagging() {
        const customData = {
            nombrePagina: 'minimumInvestmentPercentage',
            tipoProceso: 'proc-robo-advisor-test-mifid',
            pasoProceso: 'paso_12',
            detalleProceso: 'nueva_normativa',
        };
        window &&
            window.utag &&
            window.utag.view &&
            window.utag.view(customData);
    }

    componentDidUpdate(prevProps) {
        const { immAnswers } = this.props;
        if (
            immAnswers.get('402') === 'answer3' &&
            prevProps.immAnswers.get('402') !== 'answer3'
        ) {
            this.doTagging();
        }
    }

    render() {
        const { immAnswers, immQuestions, disabled } = this.props;
        const onToggleMoreInfo = () => {
            this.setState(prev => {
                if (!prev.isAccordionExpanded) {
                    taggingEventHandled(
                        PROC_RA_SUITABILITY_TEST,
                        'moreInfoQ402',
                    );
                } else {
                    taggingEventHandled(
                        PROC_RA_SUITABILITY_TEST,
                        'lessInfoQ402',
                    );
                }

                return {
                    ...prev,
                    isAccordionExpanded: !prev.isAccordionExpanded,
                };
            });
        };

        return (
            <div>
                <RASustainabilityDisclaimer />
                <RASustainabilityModal />
                <Accordion
                    dividerLineDown
                    isExpanded={this.state.isAccordionExpanded}
                    headerHidden={immAnswers.get('402') !== 'answer3'}
                    allowSingleExpand
                    onToggle={onToggleMoreInfo}
                >
                    <AccordionHeader
                        name="AccordionHeader"
                        isRightArrowPosition
                        iconStyle
                    >
                        <div className="ra-suitability-test-accordion__icon-section--separator-center">
                            {!this.state.isAccordionExpanded ? (
                                <FormattedText value="raSustainabilityQuestion-accordionToggleText" />
                            ) : (
                                <FormattedText value="raSustainabilityQuestion-accordionToggleTextLess" />
                            )}
                        </div>
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <div
                            className={
                                'ra-suitability-test-factors-question__last-step-left'
                            }
                        >
                            <RARadioButtonStep
                                className="ra-suitability-test-factors-question__last-step-inner"
                                selectedValue={immAnswers.get('402')}
                                titleText={immQuestions.getIn(['402', 'title'])}
                                subTitleText={''}
                                explanationText={''}
                                radioButtons={immQuestions
                                    .getIn(['402', 'answers'])
                                    .toJS()}
                                nameComponent={'ask402'}
                                idPrefix={'ask402'}
                                changeSelectedOption={answer => {
                                    this.setState(prev => {
                                        if (answer === 'answer3') {
                                            this.doTagging();
                                            return {
                                                ...prev,
                                                isAccordionExpanded: false,
                                            };
                                        } else {
                                            this.props.cleanSutainabilityExtraQuestions();
                                            return {
                                                ...prev,
                                                isAccordionExpanded: true,
                                            };
                                        }
                                    });

                                    this.props.setSustainabilityInvestmentFactors(
                                        answer,
                                    );
                                }}
                                disabled={disabled}
                            />
                        </div>
                    </AccordionBody>
                </Accordion>

                {immAnswers.get('402') === 'answer3' ? (
                    <div>
                        <div className="ra-suitability-test-factors-question__last-step-left">
                            <RARadioButtonStep
                                className="ra-suitability-test-factors-question__last-step-inner"
                                selectedValue={immAnswers.get('403')}
                                titleText={immQuestions.getIn(['403', 'title'])}
                                subTitleText={''}
                                explanationText={''}
                                radioButtons={immQuestions
                                    .getIn(['403', 'answers'])
                                    .toJS()}
                                nameComponent={'ask403'}
                                idPrefix={'ask403'}
                                changeSelectedOption={
                                    this.props.setSustainabiltyPias
                                }
                                disabled={disabled}
                            />
                        </div>

                        <div className="ra-suitability-test-factors-question__last-step-left">
                            <RARadioButtonStep
                                className="ra-suitability-test-factors-question__last-step-inner"
                                selectedValue={immAnswers.get('404')}
                                titleText={immQuestions.getIn(['404', 'title'])}
                                subTitleText={''}
                                explanationText={''}
                                radioButtons={immQuestions
                                    .getIn(['404', 'answers'])
                                    .toJS()}
                                nameComponent={'ask404'}
                                idPrefix={'ask404'}
                                changeSelectedOption={
                                    this.props.setSustainabiltyTaxonomia
                                }
                                disabled={disabled}
                            />
                        </div>

                        <div className="ra-suitability-test-factors-question__last-step-left">
                            <RARadioButtonStep
                                className="ra-suitability-test-factors-question__last-step-inner"
                                selectedValue={immAnswers.get('405')}
                                titleText={immQuestions.getIn(['405', 'title'])}
                                subTitleText={''}
                                explanationText={''}
                                radioButtons={immQuestions
                                    .getIn(['405', 'answers'])
                                    .toJS()}
                                nameComponent={'ask405'}
                                idPrefix={'ask405'}
                                changeSelectedOption={
                                    this.props
                                        .setSustainabiltyInvestmentObjective
                                }
                                disabled={disabled}
                            />
                        </div>
                    </div>
                ) : (
                    <div></div>
                )}
            </div>
        );
    }
}

RASustainabilityInvestmentFactorsQuestion.propTypes = {
    immSuitabilityTest: PropTypes.object.isRequired,
    immWizard: PropTypes.object.isRequired,
    immQuestions: PropTypes.object.isRequired,
    immAnswers: PropTypes.object.isRequired,
    disabled: PropTypes.boolean,
    setSustainabilityInvestmentFactors: PropTypes.func.isRequired,
    setSustainabiltyPias: PropTypes.func.isRequired,
    setSustainabiltyTaxonomia: PropTypes.func.isRequired,
    setSustainabiltyInvestmentObjective: PropTypes.func.isRequired,
    setSustainabiltyOurStrategies: PropTypes.func.isRequired,
    cleanSutainabilityExtraQuestions: PropTypes.func.isRequired,
};

module.exports = RASustainabilityInvestmentFactorsQuestion;
